module.exports = __webpack_public_path__ + "img/innovation.6e6b239.webp";